import type { Event } from '@mr-website/schemas';
import type { GuestRow } from './GuestSection';
import {
  createDefaultSpouseFields,
  createInitialSpouseState,
  type SpouseFormState,
} from './SpouseSection';
import type { LinkedSpouse } from './types';
import { createGuestId } from './utils';

function createInitialGuestState(): { guests: GuestRow[]; guestCount: number } {
  return { guests: [], guestCount: 0 };
}

export function createSpouseStateFromUserRsvp(
  linkedSpouse: LinkedSpouse | null,
  userRsvp?: Event['user_rsvp'],
): SpouseFormState {
  if (!userRsvp?.has_spouse) {
    return createInitialSpouseState(linkedSpouse);
  }

  if (linkedSpouse) {
    return {
      enabled: true,
      fields: {
        ...createDefaultSpouseFields(linkedSpouse),
        send_invite: userRsvp.spouse?.send_invite ?? false,
      },
    };
  }

  return {
    enabled: true,
    fields: {
      first_name: userRsvp.spouse?.first_name ?? '',
      last_name: userRsvp.spouse?.last_name ?? '',
      send_invite: userRsvp.spouse?.send_invite ?? false,
    },
  };
}

export function createGuestStateFromUserRsvp(userRsvp?: Event['user_rsvp']): {
  guests: GuestRow[];
  guestCount: number;
} {
  const guests = (userRsvp?.guests ?? []).map((guest) => ({
    id: createGuestId(),
    first_name: guest.first_name,
    last_name: guest.last_name,
    send_invite: guest.send_invite,
    email: guest.email,
  }));

  return {
    guests,
    guestCount: guests.length,
  };
}

export function createRsvpFormState(
  linkedSpouse: LinkedSpouse | null,
  userRsvp?: Event['user_rsvp'],
): {
  spouse: SpouseFormState;
  guestState: { guests: GuestRow[]; guestCount: number };
} {
  if (!userRsvp) {
    return {
      spouse: createInitialSpouseState(linkedSpouse),
      guestState: createInitialGuestState(),
    };
  }

  return {
    spouse: createSpouseStateFromUserRsvp(linkedSpouse, userRsvp),
    guestState: createGuestStateFromUserRsvp(userRsvp),
  };
}
